import { useModuleStepLog } from '@ctcells/api'
import { t } from '@ctcells/i18n'

import { latestStepOf, latestStepText, type SequenceDictionary } from './latestStepModel.ts'

/**
 * 「처리 중」 장치 그림 바로 아래 한 줄 — **이벤트 로그 「내용」 열의 그 글자만**(eric 2026-10-08 「이벤트 로그에서.. 내용만 보여줘.. 바로 밑에..
 * 각각의 장비에서.. 처리 중인 기기 밑에 넣어줘」 → 「스텝 보여달라는 얘기했어? 안했어?」 — 스텝 수는 안 붙인다).
 * 재료는 구독이 쌓은 **모듈별** 스텝 줄(`useModuleStepLog`)의 맨 끝 — 작업 귀속과 무관이라 `batch_id` 없는 6축 프레임도 선다(eric 「6축 로봇에서
 * 아래에 스텝의 내용 보이게 해줘」). 폴링 아님 · 짓지 않음.
 * 🔴 끊긴 화면(`stale`)이면 마지막 줄을 「지금」으로 보이지 않는다 — 안 그린다.
 */
export function LatestStepNote({
  moduleId,
  name,
  stale,
  sequences,
  inHeader = false,
}: {
  moduleId: string | undefined
  name: string
  stale: boolean
  /** 통합 콘솔의 처리 중 머리칸 둘째 줄. */
  inHeader?: boolean
  /** 그 장비의 시퀀스 사전 — 있으면 말의 머리(시퀀스 원값)를 한글 이름으로(`latestStepText`) */
  sequences?: SequenceDictionary | undefined
}) {
  const rows = useModuleStepLog(moduleId)
  const row = stale ? undefined : latestStepOf(rows, moduleId)
  if (row === undefined) return null
  // 처리 중 머리칸은 서버 단계 문구만 표시한다. 사건 라벨로 빈 문구를 채우지 않는다.
  if (inHeader && (row.eventType !== 'step_complete' || !row.message?.trim())) return null
  const text = latestStepText(row, sequences)
  if (text.trim() === '') return null
  return (
    <p
      aria-label={t('monitoring.eqsheet.latestStep', { name })}
      className={inHeader ? 'eqsheet__stepnote' : 'eqsheet__evnote'}
      data-event-type={row.eventType}
      data-part="latest-step"
    >
      {text}
    </p>
  )
}
